import { render, staticRenderFns } from "./MenuImportPanel.vue?vue&type=template&id=6814b712&scoped=true&"
import script from "./MenuImportPanel.vue?vue&type=script&lang=js&"
export * from "./MenuImportPanel.vue?vue&type=script&lang=js&"
import style0 from "./MenuImportPanel.vue?vue&type=style&index=0&id=6814b712&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6814b712",
  null
  
)

export default component.exports